// Meta Pixel — runtime injection, guarded on VITE_META_PIXEL_ID.
// No npm dependencies; plain DOM manipulation only.

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & { queue?: unknown[] };
    _fbq?: Window['fbq'];
  }
}

export function initMetaPixel(): void {
  const pixelId = import.meta.env.VITE_META_PIXEL_ID as string | undefined;
  if (!pixelId) return;

  // Standard Meta base code (minified IIFE)
  const f = window;
  const b = document;
  if (f.fbq) return; // already initialised

  const n: NonNullable<Window['fbq']> = Object.assign(
    function (this: unknown, ...args: unknown[]) {
      if (n.queue) n.queue.push(args);
    },
    { queue: [] as unknown[] },
  );
  f.fbq = n;
  if (!f._fbq) f._fbq = n;

  const s = b.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const first = b.getElementsByTagName('script')[0];
  first.parentNode?.insertBefore(s, first);

  f.fbq('init', pixelId);
  f.fbq('track', 'PageView');

  // <noscript> fallback pixel
  const ns = b.createElement('noscript');
  const img = b.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
  ns.appendChild(img);
  b.body.appendChild(ns);
}

/** Fire a standard Meta event. Silent no-op when the pixel isn't loaded or is blocked. */
export function trackMetaEvent(event: string): void {
  if (typeof window.fbq === 'function') {
    window.fbq('track', event);
  }
}
